import type {PartialOptions} from "../../../../../../stem-core/ui/UIBase";
import {UI} from "../../../../../../stem-core/ui/UIBase";
import {StyleSheet, registerStyle, styleRule} from "../../../../../../stem-core/ui/Style";
import {SubscriptionCoveragePerk, SubscriptionCoverageTitle} from "./CoverageDescriptionElements";
import {PlusIcon} from "../../../../../../core/ui/SVGElements.jsx";


class PlusIconStyle extends StyleSheet {
    @styleRule
    container = {
        margin: "auto",
        padding: "4px 0px",
    }
}

@registerStyle(PlusIconStyle)
class PlusIconElement extends PlusIcon {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            size: 14,
        }
    }
}

export const DescriptionItemType = {
    PERK: "perk",
    PLUS: "plus",
    COVERAGE: "coverage",
};

const descriptionComponentMap = {
    [DescriptionItemType.PERK]: SubscriptionCoveragePerk,
    [DescriptionItemType.COVERAGE]: SubscriptionCoverageTitle,
    [DescriptionItemType.PLUS]: PlusIconElement, // TODO @cleanup this should be a function () => <PlusIcon ... />
};

class CoverageDescriptionStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        flexDirection: "column",
        marginBottom: "auto",
        ">:not(:last-child)": {
            marginBottom: 8,
        },
    }
}

interface CoverageDescriptionOptions {
    items?: any[];
}

@registerStyle(CoverageDescriptionStyle)
export class CoverageDescription extends UI.Element<CoverageDescriptionOptions> {
    getDefaultOptions(): PartialOptions<CoverageDescription> {
        return {
            ...super.getDefaultOptions(),
            items: [],
        }
    }

    render() {
        return (this.options.items || []).map(item => {
            const DescriptionComponentClass = descriptionComponentMap[item.type];
            return <DescriptionComponentClass {...item} />
        })
    }
}
